// extracted by mini-css-extract-plugin
export default {"charts":"style_charts__rjEW5","chart":"style_chart__7aqFR"};